module.exports = __webpack_public_path__ + "static/media/beginning.png";